<div class="google-place-autocomplete-container">

  <!-- Address input -->
  <input
    #addressInput
    type="text"
    class="google-place-autocomplete-input"
    [readonly]="readonly"
    [attr.maxlength]="maxlength"
    [attr.placeholder]="placeholder || null"
    autocomplete="off"
    (input)="onInput($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (keydown)="onKeyDown($event)"
  />


  <!-- Prediction dropdown -->
  <div
    class="google-place-predictions"
    *ngIf="showPredictions && predictions.length > 0"
  >

    <button
  type="button"
  class="google-place-prediction"
  *ngFor="let prediction of predictions; let i = index"
  [class.active]="i === activePredictionIndex"
  (mousedown)="selectPrediction(prediction, $event)">

  <span class="prediction-text">

    <span class="prediction-main">
      {{ getPredictionMainText(prediction) }}
    </span>

    <span
      class="prediction-secondary"
      *ngIf="getPredictionSecondaryText(prediction)">

      {{ getPredictionSecondaryText(prediction) }}

    </span>

  </span>

</button>


    <!-- Google attribution -->
    <div class="google-attribution">
      <span>Google</span>
    </div>

  </div>

</div>